import { render, staticRenderFns } from "./CourseContentSectionChild.vue?vue&type=template&id=02fcb616&scoped=true"
import script from "./CourseContentSectionChild.vue?vue&type=script&lang=js"
export * from "./CourseContentSectionChild.vue?vue&type=script&lang=js"
import style0 from "./CourseContentSectionChild.vue?vue&type=style&index=0&id=02fcb616&prod&lang=css"
import style1 from "./CourseContentSectionChild.vue?vue&type=style&index=1&id=02fcb616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fcb616",
  null
  
)

export default component.exports